const LoginInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    user: {},
    status: false,
    isAdmin: false,
    isGuest: false
  },
  mutations: {
    onAuthStateChanged(state, user) {
      state.user = user;
    },
    adminUser(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setSignedIn(state, login) {
      state.status = login;
    },
    guestUser(state, isGuest) {
      state.isGuest = isGuest;
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    isSignedIn(state) {
      return state.status;
    },
    isAdmin(state) {
      return state.isAdmin;
    },
    isGuest(state) {
      return state.isGuest;
    }
  },
  actions: {
    async setUserInfo({ commit }, user) {
      commit("onAuthStateChanged", user);
      if (user !== null) {
        await user.getIdTokenResult(true).then(idTokenResult => {
          if (idTokenResult.claims.admin) {
            commit("adminUser", true);
          } else {
            commit("adminUser", false);
          }
        });
      } else {
        commit("adminUser", false);
      }
    },
    async setSignedIn({ commit }, loginFlag) {
      commit("setSignedIn", loginFlag);
    },
    async setGuest({ commit }, isGuest) {
      commit("guestUser", isGuest);
    }
  }
};
export default LoginInfoStore;
